module.exports = __webpack_public_path__ + "static/media/activity_context.2b71ae30.png";